import React from 'react';
import { motion } from 'framer-motion';
import BlogSection from '../components/BlogSection';
import { useLanguage } from '../contexts/LanguageContext';

const BlogPage = () => {
  const { t } = useLanguage();

  return (
    <main className="pt-20 min-h-screen bg-white" data-testid="blog-page">
      {/* Header */}
      <section className="py-16 md:py-24 bg-[#F5F5F7]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="text-center"
          >
            <h1 className="font-['Manrope'] font-bold tracking-tighter text-[#1D1D1F] text-5xl md:text-7xl mb-6">
              {t.blog.title}
            </h1>
            <p className="font-['Inter'] text-lg md:text-xl text-[#86868B] max-w-2xl mx-auto">
              {t.blog.subtitle}
            </p>
          </motion.div>
        </div>
      </section>

      {/* Blog Content */}
      <BlogSection showAll={true} showSearch={true} />
    </main>
  );
};

export default BlogPage;
